(() => {
  const init = (root) => {
    const productField = root.querySelector('[data-request-product]');
    const productUrlField = root.querySelector('[data-request-product-url]');
    if (!productField && !productUrlField) return;

    const params = new URLSearchParams(location.search);
    const product = params.get('product')?.trim();
    if (productField && !productField.value.trim() && product) productField.value = product;

    const productUrl = params.get('product_url');
    if (!productUrlField || !productUrl) return;

    try {
      const url = new URL(productUrl, location.origin);
      const allowedProtocol = url.protocol === 'https:' || url.protocol === 'http:';
      if (allowedProtocol && url.origin === location.origin && url.pathname.startsWith('/products/')) {
        productUrlField.value = url.href;
      }
    } catch (_) {}
  };

  document.querySelectorAll('[data-request-information]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.matches('[data-request-information]')) init(event.target);
    event.target.querySelectorAll('[data-request-information]').forEach(init);
  });
})();
